<template>
  <div>

    <b-loading :active=!worksLoaded></b-loading>

    <b-modal
      :active.sync="isImageModalActive"
      :width="modalMediaWidth"
      animation="fade-in"
      scroll="keep"
      class="modal-container"
    >

      <!-- div purely as a container to allow a closeable click -->
      <div
        @click="close_modal"
      >
        <h1 class="title modal-title">
          {{ modaltitle }}
        </h1>

        <post-media 
          :postmedia="primaryMedia"
          class="primary-media"
        ></post-media>
      </div>
    </b-modal>

      <div
        v-show="worksLoaded"
        class="columns is-marginless is-multiline">
        
          <div
            v-for="(workpost, index) in worksFiltered" :key="workpost.id" 
            class="column workpost is-half"
            :class="{'offset': index % 2 != 0 }"
            v-bind:id="'work-' + workpost.id"
          >
            <a
              @click="toggle_modal(workpost)">
              <spread-thumb :workpost="workpost"></spread-thumb>       
            </a>
          </div>
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "WorkSpread",
  data() {
    return {
      router_type: this.$route.params.type,
      isImageModalActive : false,
      modalsrc: String,
      modaltitle: String,
      quickview_workpost: undefined,
      loading: false,
      modalMediaWidth: 960
    }
  },
  watch: {
    '$route'(to) {
      this.router_type = to.params.type
      // this.$store.dispatch('messages/getMessage', this.router_type)
    },
  },
  computed: {
    primaryMedia() {
        if (this.quickview_workpost == undefined) {
          return false
        }

        let filtered = this.quickview_workpost.postmedia_set.filter(work => {
          return work.primary === true
        })
        return filtered[0]
      },
    worksLoaded() {
      if (this.works.length < 2) {
        return false
      }
      else {
        return true
      }
    },
    worksFiltered() {
      // this whole system could be better hah, use some form of tags!?
      let commercial = false
      
      // get type
      if (this.router_type == 'commercialwork') {
        commercial = true
      }

      // if undefined then do not filter at all
      if (this.router_type == undefined) {
        return this.works
      }

      let filtered = this.works.filter(work => {
        // return work.status
        return work.status === true && work.commercial_work === commercial;
      })
  
      return filtered
    },
    ...mapState({
      works: state => state.messages.works,
      works_loading: state => state.messages.works_loading,
      works_next_page: state => state.messages.works_next_page,
    })
  },
  methods: {
    toggle_modal: function(workpost) {
      this.quickview_workpost = workpost
      this.isImageModalActive = !this.isImageModalActive
      this.modalsrc = this.quickview_workpost.thumbnail
      this.modaltitle = this.quickview_workpost.title

      // bodgy but at the moment array IS only 1
      let aspect_ratio = this.quickview_workpost.postmedia_set[0].aspect_ratio

      if (aspect_ratio > 1) {      
        this.modalMediaWidth = 1280
      }
      else {
        this.modalMediaWidth = 960
      }
    },
    close_modal() {
      this.isImageModalActive = false
    },
    mouseOver: function() {
      this.active = !this.active;   
    },
    FileIsVideo(file) {
        if (file === null) {
          return false
        }

        let upload = file
               
        // check extension
        let video_extensions = ['mp4']

        // links to aws now are presigned so there is a lot of text after the '?'
        // so split there to get the actual file path
        let file_url = upload.split("?")[0]

        // if file extension is a video
        if (video_extensions.includes(file_url.split(".").pop().toLowerCase())) {
            return true
        }
        else {
            return false
        }
    },
    InfinteScroll() {
      // detects scrolling to the bottom of the browser and runs the GetNextPage function
      window.onscroll = () => {
          let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight -200 ;
          
          // only run if not already loading (doing a request) and at the bottom of the window
          if ((bottomOfWindow) && (this.works_loading == false)) {
            this.$store.commit('messages/addWorks', this.works_next_page)
          }
      }
    },
  },
  mounted() {
    this.$store.dispatch('messages/getMessages', 1)
    this.InfinteScroll()
  },
}
</script>

<style lang="scss" scoped>

@import '~bulma/sass/utilities/_all';

  .modal-container {
    cursor: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 512 512'%3e%3cg transform='rotate(45 256 256)'%3e%3crect id='r' x='16' y='216' width='480' height='80' rx='14'/%3e%3cuse href='%23r' transform='rotate(90 256 256)'/%3e%3c/g%3e%3c/svg%3e") 16 16, pointer;
  }
  .modal-title {
    color: #fff;
    text-align: center;
    // top: 0;
    // left: 50%;
    // position: fixed;
    // margin: 2rem -15rem;
    // width: 30rem;
  }
  .column {
    position: relative;
    padding: 1vw;
    line-height: 0;
  }
  .columns {
    margin-bottom: 1rem !important;
  }
  .primary-media {
    margin: 1rem auto;
    max-height: 75%;
    max-width: 90%;
  }
  .offset {
    top: 15vw;
  }

  @include mobile {
    .main-media {
      width: 100%;
    }
    .workpost {
      height: auto; // without a set height, inital scrolling doesnt end in the correct pos
      // padding: .5em 0em 1em 0;
    }
    .column {
      padding: 0.25rem 0.5rem;
    }
  .offset {
    top: 0;
    }
  }

</style>
